import { render } from "./ProductDetail_AuditOperation.vue?vue&type=template&id=67c57fab&scoped=true"
import script from "./ProductDetail_AuditOperation.vue?vue&type=script&lang=js"
export * from "./ProductDetail_AuditOperation.vue?vue&type=script&lang=js"

import "./ProductDetail_AuditOperation.vue?vue&type=style&index=0&id=67c57fab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c57fab"]])

export default __exports__